import React from 'react';
import { 
  PencilIcon, 
  TrashIcon,
  UserIcon,
  EnvelopeIcon,
  PhoneIcon
} from '@heroicons/react/24/outline';

const ClientTableRow = ({ client, onEdit, onDelete }) => {
  return (
    <tr>
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="flex items-center">
          <div className="flex-shrink-0 h-10 w-10">
            <div className="h-10 w-10 rounded-full bg-gray-300 flex items-center justify-center">
              <UserIcon className="h-6 w-6 text-gray-600" />
            </div>
          </div>
          <div className="ml-4">
            <div className="text-sm font-medium text-gray-900">
              {client.name}
            </div>
            <div className="text-sm text-gray-500">
              {client.address}
            </div>
          </div>
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="text-sm text-gray-900 flex items-center">
          <EnvelopeIcon className="h-4 w-4 mr-2 text-gray-400" />
          {client.email}
        </div>
        <div className="text-sm text-gray-500 flex items-center">
          <PhoneIcon className="h-4 w-4 mr-2 text-gray-400" />
          {client.phone}
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
        {client.company || '-'}
      </td>
      <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
        <button
          onClick={() => onEdit(client)}
          className="text-indigo-600 hover:text-indigo-900 mr-4"
        >
          <PencilIcon className="h-4 w-4" />
        </button>
        <button
          onClick={() => onDelete(client.id)}
          className="text-red-600 hover:text-red-900"
        >
          <TrashIcon className="h-4 w-4" />
        </button>
      </td>
    </tr>
  );
};

export default ClientTableRow;
